import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessServices } from "@/components/ProjectSidebar/permissions";

import { RequireAuth } from "../../components/Routing/RequireAuth";
import { CreateServicePartnerPage } from "./pages/CreateServicePartnerPage";
import { EditServicePartnerPage } from "./pages/EditServicePartnerPage";
import { ServicePartnerDetailsPage } from "./pages/ServicePartnerDetailsPage";
import { ServicePartnerListPage } from "./pages/ServicePartnerListPage";
import { canCreateNewServicePartner, canViewServicePartners } from "./permissions";
import { servicePartnersRoutes } from "./routes";

export const servicePartnersRoute = [
  {
    path: servicePartnersRoutes.list,
    element: (
      <RequireAuth permission={canAccessServices}>
        <ServicePartnerListPage />
      </RequireAuth>
    ),
  },
  {
    path: servicePartnersRoutes.details,
    element: (
      <RequireAuth permission={canViewServicePartners}>
        <ServicePartnerDetailsPage />
      </RequireAuth>
    ),
  },
  {
    path: servicePartnersRoutes.create,
    element: (
      <RequireAuth permission={canCreateNewServicePartner}>
        <CreateServicePartnerPage />
      </RequireAuth>
    ),
  },
  {
    path: servicePartnersRoutes.edit,
    element: (
      <RequireAuth permission={canViewServicePartners}>
        <EditServicePartnerPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
